import { useEffect } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Logs a share-attribution hit when the current page is loaded with
 * `?utm_source=…&utm_medium=share`. Public endpoint, no auth required.
 *
 * Idempotent within a session — uses `sessionStorage` so reloads /
 * back-button traversals don't double-count.
 */
export function useShareAttribution() {
  useEffect(() => {
    if (typeof window === "undefined") return;
    const params = new URLSearchParams(window.location.search);
    const utm_source = params.get("utm_source");
    const utm_medium = params.get("utm_medium");
    if (!utm_source) return;
    const key = `nodera-share-logged::${window.location.pathname}::${utm_source}::${utm_medium || ""}`;
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, "1");
    axios
      .post(`${BACKEND_URL}/api/public/share-events/log`, {
        utm_source,
        utm_medium: utm_medium || "share",
        utm_campaign: params.get("utm_campaign") || null,
        page: window.location.pathname + window.location.search,
        referrer: document.referrer || null,
      })
      .catch(() => {
        /* attribution is best-effort; never blocks the page */
      });
  }, []);
}

export default useShareAttribution;
